export enum SystemSettingsPage {
  SYSTEM = 'system',
  ACCOUNTS = 'accounts',
  ACCOUNT = 'account',
  CAFEX_IDENTITY = 'cafexIdentity',
  // Add further enums as you implement the screens
}
